<template>
  <v-card class="text-xs-center">
    <h1 class="pa-3">
      MERCHANT DOCUMENT APPROVE
      <v-btn icon @click="initial()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </h1>
    <document-approve-table
      :itemList="documentList"
      :itemDetail="documentDetail"
      :isLoadingList="isLoadingList"
      :isLoadingDetail="isLoadingDetail"
      @fetchDetail="fetchDocument($event)"
      @approve="approveDocument($event)"
      @reject="rejectDocument($event)"
      :isApproving="isApproving"
      :isRejecting="isRejecting"
    ></document-approve-table>
  </v-card>
</template>

<script>
import documentApproveTable from "@/components/back-office/Merchant/DocumentApprove/DocumentApproveListTable";
import { mapState } from "vuex";
import CryptoJS from "crypto-js";
export default {
  components: {
    "document-approve-table": documentApproveTable,
  },
  data() {
    return {
      isApproving: false,
      isLoadingList: false,
      isLoadingDetail: false,
      isRejecting: false,
    };
  },
  computed: {
    ...mapState({
      documentDetail: (state) => state.fetchStoreApproveBack.documentDetail,
      documentList: (state) => state.fetchStoreApproveBack.documentList,
    }),
  },
  async created() {
    this.initial();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Product approve",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  methods: {
    async approveDocument(form) {
      this.isApproving = true;
      let obj = {
        store_id: form.store_id,
        province: form.province,
      };
      const result = await this.$store.dispatch(
        "fetchStoreApproveBack/approveDocument",
        obj
      );
      if (result === true) {
        form.done();
      } else {
        alert("Some thing went wrong!!");
      }
      this.isApproving = false;
    },
    async rejectDocument(form) {
      let data = {
        province_id: form.province_id,
        store_id: form.store_id,
        province: form.province,
      };
      let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        "s9d333dkj1594ro"
      )
        .toString()
        .replace(/\+/g, "p1L2u3S")
        .replace(/\//g, "s1L2a3S4h")
        .replace(/=/g, "e1Q2u3A4l");

      let obj = {
        store_id: form.store_id,
        province: form.province,
        url_hash:
          `${process.env.VUE_APP_BACKOFFICE_URL}/document?cer=` + encrypted,
        msg: form.msg,
      };
      this.isRejecting = true;
      const result = await this.$store.dispatch(
        "fetchStoreApproveBack/rejectDocument",
        obj
      );
      if (result === true) {
        form.done();
      } else {
        alert("Some thing went wrong!!");
      }
      this.isRejecting = false;
    },
    async initial() {
      this.fetchDataList();
    },
    async fetchDataList() {
      await this.$store.dispatch("fetchStoreApproveBack/getDocumentList");
    },
    async fetchDocument(configPath) {
      this.isLoadingDetail = true;
      console.log(configPath);
      await this.$store.dispatch(
        "fetchStoreApproveBack/getDocumentByStore",
        configPath
      );
      this.isLoadingDetail = false;
    },
  },
};
</script>

<style>
</style>
